<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 项目基本资料</div>
    <ul class="project-info-list">
      <!-- {{ form.type }} -->
      <div v-if="form.type==6">
        <li>
          <label>资金申请单位：</label>
          <div class="info-item">{{ form.fkdw }}</div>
        </li>
        <li>
          <label>申请使用日期：</label>
          <div class="info-item">{{ getFormatDate(form.flow.createTime) }}</div>
        </li>
        <li>
          <label>申请金额(大写)：</label>
          <div class="info-item">{{ form.dxje }}</div>
        </li>
        <li>
          <label>申请金额(元)：</label>
          <div class="info-item">{{ form.htjk }}</div>
        </li>
        <li>
          <label>资金内容：</label>
          <div class="info-item">{{ form.remark }}</div>
        </li>
      </div>
      <div v-else-if="form.type==5">
        <li>
          <label>付款单位：</label>
          <div class="info-item">{{ form.fkdw }}</div>
        </li>
        <div v-if="!form.isAlone">
          <li>
            <label>合同编号：</label>
            <div class="info-item">{{ form.contractVO.htbh }}</div>
          </li>
          <li>
            <label>合同名称：</label>
            <div class="info-item">{{ form.htmc }}</div>
          </li>
          <li>
            <label>合同期限：</label>
            <div class="info-item">{{ form.htqx }}</div>
          </li>
        </div>
        <li>
          <label>收款单位：</label>
          <div class="info-item">{{ form.htdf }}</div>
        </li>
        <li>
          <label>采购方式：</label>
          <div class="info-item">{{ form.cgfs }}</div>
        </li>
        <li>
          <label>合同金额：</label>
          <div class="info-item">{{ form.htjk?form.htjk:'/' }}</div>
        </li>
        <li class="half">
          <label>补充合同：</label>
          <div class="info-item">{{ form.bcht1 }}</div>
        </li>
        <li class="half">
          <label>补充合同：</label>
          <div class="info-item">{{ form.bcht2 }}</div>
        </li>
        <li>
          <label>累计已完成(元)：</label>
          <div class="info-item">{{ form.ywchtje }}</div>
        </li>
        <li>
          <label>累计已支付(元)：</label>
          <div class="info-item">{{ form.ljzfjk }}</div>
        </li>
        <li>
          <label>本期采购金额(元)：</label>
          <div class="info-item">{{ form.bqcgje }}</div>
        </li>
        <li>
          <label>本期应支付(元)：</label>
          <div class="info-item">{{ form.bqzf }}</div>
        </li>
        <li class="block">
          <label>经办人意见：</label>
          <div class="info-item">{{ form.remark }}</div>
        </li>
      </div>
      <div v-else>
        <li v-if="!form.isAlone">
          <label>合同名称：</label>
          <div class="info-item">{{ form.htmc }}</div>
        </li>
        <li v-else>
          <label>付款名称：</label>
          <div class="info-item">{{ form.name }}</div>
        </li>
        <li>
          <label>付款单位：</label>
          <div class="info-item">{{ form.fkdw }}</div>
        </li>
        <li>
          <label>款项类别：</label>
          <div class="info-item">{{ form.payType }}</div>
        </li>
        <li>
          <label>对方单位：</label>
          <div class="info-item">{{ form.htdf }}</div>
        </li>
        <li>
          <label>委托方式：</label>
          <div class="info-item">{{ form.wtfs }}</div>
        </li>
        <li>
          <label>(合同/支付)价款(元)：</label>
          <div class="info-item">{{ form.htjk }}</div>
        </li>
        <li>
          <label>补充价款(元)：</label>
          <div class="info-item">{{ form.bcjk }}</div>
        </li>
        <li>
          <label>支付期数：</label>
          <div class="info-item">第{{ form.zfqs }}期</div>
        </li>
        <li>
          <label>本期审核价款(元)：</label>
          <div class="info-item">{{ form.bqshjk }}</div>
        </li>
        <li>
          <label>本期前累计支付(元)：</label>
          <div class="info-item">{{ form.ljzfjk }}</div>
        </li>
        <li class="block label-li2">
          <label>本期支付(支付至审核价款的 %)：</label>
          <div class="info-item">{{ form.bqzf+'('+form.zfzshzj+'%)'}}</div>
        </li>
        <li class="block">
          <label>支付简注：</label>
          <div class="info-item">{{ form.remark }}</div>
        </li>
      </div>

    </ul>

  </section>
</template>
<script>
  export default {
    props: ['form', 'userData'],
    data() {
      return {
        // form: {}
      }
    },
    mounted() {
      // this.form = this.formByFather
    },
    methods: {
      getFormatDate(time) {
        return util.getFormatDate(time, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/createPay.vue